export const kanbanMessageLinks = (content, { origin, accountId }) => {
  const links = new Map();
  const candidates =
    String(content || '').match(
      /https?:\/\/[^\s<>]+|\/app\/accounts\/[^\s<>]+/g
    ) || [];
  candidates.forEach(candidate => {
    try {
      const url = new URL(candidate.replace(/[),.;!?]+$/, ''), origin);
      const route = url.pathname.match(
        /^\/app\/accounts\/(\d+)\/(?:v2\/)?kanban\/?$/
      );
      const itemId = url.searchParams.get('item');
      if (
        url.origin !== origin ||
        !route ||
        route[1] !== String(accountId) ||
        !/^[1-9]\d*$/.test(itemId || '')
      )
        return;
      links.set(itemId, { itemId, href: `${url.pathname}${url.search}` });
    } catch {
      // Non-URLs remain ordinary message text.
    }
  });
  return [...links.values()].slice(0, 3);
};
